module.exports = __webpack_public_path__ + "img/vertical_6_4_8011.17ee625d.png";